import { render, staticRenderFns } from "./AboutEnnetix.vue?vue&type=template&id=033867a8&"
import script from "./AboutEnnetix.vue?vue&type=script&lang=js&"
export * from "./AboutEnnetix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports